import { configure, defineRule } from 'vee-validate';
import * as AllRules from '@vee-validate/rules';

import type { FieldValidationMetaInfo } from '@vee-validate/i18n';
import { localize, setLocale } from '@vee-validate/i18n';
import moment from 'moment';

const getParam = (ctx: FieldValidationMetaInfo, index: number) => {
  const params = ctx.rule?.params as unknown[];

  return params[index];
};

Object.keys(AllRules)
  .filter((item) => item !== 'all')
  .forEach((rule) => {
    defineRule(rule, AllRules[rule]);
  });

defineRule('phone', (value: string) => /^\+?[0-9]+$/.test(value));

defineRule('date_format', (value: string, props: [string]) => {
  const [targetValue] = props;

  if (!value || !targetValue) {
    return false;
  }

  return moment(value, targetValue, true).isValid();
});

defineRule('before', (value: string, props: [string]) => {
  const [targetValue] = props;

  if (!value || !targetValue) {
    return false;
  }

  return moment(value).isBefore(targetValue);
});

configure({
  generateMessage: localize({
    sk: {
      messages: {
        _default: (ctx) => 'Pole nie je správne',
        after: (ctx) => 'Pole musí byť po.',
        alpha_dash: (ctx) =>
          `Pole ${ctx} may contain alpha-numeric characters as well as dashes and underscores.`,
        alpha_num: (ctx) => `Pole ${ctx} may only contain alpha-numeric characters.`,
        alpha_spaces: (ctx) =>
          `Pole ${ctx} may only contain alphabetic characters as well as spaces.`,
        alpha: (ctx) => `Pole ${ctx} may only contain alphabetic characters.`,
        before: (ctx) => 'Pole nesmie obsahovať hodnotu neskoršiu ako aktuálny deň.',
        between: (ctx) =>
          `Pole musí byť medzi číslami ${getParam(ctx, 0)} a ${getParam(ctx, 1)} (vrátane).`,
        confirmed: (ctx) => 'Potvrdenie pole sa nezhoduje.',
        credit_card: (ctx) => 'Pole nie je platné.',
        date_between: (ctx) => `Pole  must be between ${getParam(ctx, 0)} and ${getParam(ctx, 1)}.`,
        date_format: (ctx) => 'Pole musí byť vo formáte "19.5.2018".',
        decimal: (ctx) =>
          `Pole ${ctx} must be numeric and may contain ${getParam(ctx, 0) === '*' ? '' : getParam(ctx, 0)} decimal points.`,
        digits: (ctx) => `Pole ${ctx} must be numeric and exactly contain digits.`,
        dimensions: (ctx) =>
          `Pole ${ctx} must be ${getParam(ctx, 0)} pixels by ${getParam(ctx, 1)} pixels.`,
        email: (ctx) => 'Pole je v zlom formáte.',
        ext: (ctx) => `Pole ${ctx} must be a valid file.`,
        image: (ctx) => `Pole ${ctx} must be an image.`,
        in: (ctx) => `Pole ${ctx} must be a valid value.`,
        ip: (ctx) => `Pole ${ctx} must be a valid ip address.`,
        max: (ctx) => `Pole nesmie byť väčšie ako ${getParam(ctx, 0)} znakov.`,
        max_value: (ctx) => `Pole musí byť ${getParam(ctx, 0)} alebo menej.`,
        mimes: (ctx) => 'Pole must have a valid file type.',
        min: (ctx) => `Pole musí byť minimálne ${getParam(ctx, 0)} znakov dlhé.`,
        min_value: (ctx) => `Pole musí byť ${getParam(ctx, 0)} alebo viac.`,
        not_in: (ctx) => 'Vyberte inú možnosť.',
        numeric: (ctx) => 'Pole may only contain numeric characters.',
        regex: (ctx) => 'Pole format is invalid.',
        required: (ctx) => 'Pole je povinné.',
        size: (ctx) => `Pole must be less than ${getParam(ctx, 0)} KB.`,
        url: (ctx) => 'Pole is not a valid URL.',
        phone: (ctx) => 'Telefónne číslo nie je v správnom formáte.',
      },
    },
  }),
});

setLocale('sk');
